module.exports = __webpack_public_path__ + "19733edfb585cb2a64c19e18d4845b61.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/mastercard.svg
// module id = 480
// module chunks = 73